namespace JupitersChoice {
    export class StartSpinnersCmd {

        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('FreeGameModel') _freeGameModel: FreeGameModel;
        @inject('FreeSpinsPromoModel') _freeSpinsPromoModel: Sapphire.FreeSpinsPromoModel;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('TranslationsManager') _translationsManager: Sapphire.TranslationsManager;
        @inject('AudioModel') _audioModel: JupitersChoice.AudioModel;
        @inject('BetModel') _betModel: Sapphire.BetModel;
        @inject('BigWinModel') _bigWinModel: BigWinModel;

        execute(): void {
            const response: any = this._server.logicResponse;
            const spinner = this._componentManager.get('Spinner');
            const freeGamePossibleAngles = [70, 160, 250, 340];
            const creditPossibleAngles = [25, 115, 205, 295];
            const creditMultiplierAngles = {
                "20": 36,
                "10": 108,
                "100": 180,
                "50": 252,
                "5": 324,
            };

            const fsMultiplierAngles = {
                "20": 36,
                "10": 108,
                "15": 180,
                "50": 252,
                "5": 324,
            };
            var outerArrowRotation = 1080;
            var innerArrowRotation = 1080;
            var closeDelay = response.feature.type === 'payout' ? 9 : 6;

            this._soundManager.play('wheel_electricity');

            if (this._soundManager.musicMuted) {
                closeDelay = 3;
            }
            var delayUntilCompleteEventFired = 6.5 + closeDelay;

            const randomIndex: number = Math.floor(Math.random() * 4);

            let iconIndex: number = randomIndex * 2;

            if (response.feature) {
                if (response.feature.type === 'payout') {
                    outerArrowRotation += creditPossibleAngles[randomIndex];
                    innerArrowRotation += creditMultiplierAngles[response.feature.value];
                } else {
                    outerArrowRotation += freeGamePossibleAngles[randomIndex];
                    innerArrowRotation += fsMultiplierAngles[response.feature.value];
                    iconIndex++;
                }

                
            }

            // Animate purple glow with the outer arrow
            const outerHighlight = this._componentManager.get('SpinnerOuterHighlight');
            outerHighlight.rotation = 0;
            TweenMax.to(outerHighlight, 5, {
                rotation: outerArrowRotation * PIXI.DEG_TO_RAD,
                ease: new Ease(BezierEasing(.25, 1, .93, 1.05), [], 0, 0),
            });

            this._soundManager.play('wheel_woosh', null, AudioConstants.WHEEL_WOOSH_VOLUME);
            /*TweenMax.delayedCall(4.5,() => {
                this._soundManager.fadeToCurve('wheel_woosh',0,0.5);
            })*/
            this._componentManager.get('OuterArrow').spin(outerArrowRotation, 5, () => {
                this._soundManager.play('wheel_result');
                this._componentManager.get(`SpinnerOuterValueLightning${iconIndex + 1}`).play();
                this._componentManager.get(`SpinnerOuterValue${iconIndex + 1}`).play();
                this._soundManager.stop('wheel_woosh');

                if (response.feature.type === 'payout') {
                    for (const key of Object.keys(creditMultiplierAngles)) {
                        this._componentManager.get(`SpinnerInnerValue${key}X`).show();
                    }
                }else{
                    for (const key of Object.keys(fsMultiplierAngles)) {
                        this._componentManager.get(`SpinnerInnerValue${key}X`).show();
                    }
                }

                this._soundManager.play('wheel_woosh', null, AudioConstants.WHEEL_WOOSH_VOLUME);
                /*TweenMax.delayedCall(4.5,() => {
                    this._soundManager.fadeToCurve('wheel_woosh',0,0.5);
                })*/
                TweenMax.delayedCall(.5, () => {
                    this._componentManager.get('InnerArrow').spin(innerArrowRotation, 5, () => {
                        //stop base game music
                        this._soundManager.play('reel_stop_wild');
                        // Aniamte highlighted value
                        const highlightValue = this._componentManager.get(`SpinnerInnerValueHighlight${response.feature.value}X`);
                        const highlightInitialScale = this._orientationModel.isLandscape ? 1 : .67;
                        highlightValue.scale.set(highlightInitialScale);
                        highlightValue.show();
                        TweenMax.to(highlightValue.scale, .2, {
                            x: highlightInitialScale * 1.5,
                            y: highlightInitialScale * 1.5,
                            ease: Back.easeIn
                        });
                        this._soundManager.stop('wheel_woosh');

                        this._soundManager.fadeToCurve('ambient_music_level_1', 0, 1000);
                        this._soundManager.fadeToCurve('ambient_music_level_2', 0, 1000);

                        TweenMax.delayedCall(1, () => {
                            // Show layer
                            this._layerManager.setVisibility('Modals', true);
                            this._componentManager.get('FreeGamePopup').show();

                            if (response.feature.value > 5) {
                                this._componentManager.get('JupiterBaseGame').changeAnimation('laugh');
                                //laugh damnit
                                if (response.feature.type === 'payout') {
                                    TweenMax.delayedCall(0.5, () => {
                                        TweenMax.delayedCall(0.85, () => {
                                            this._soundManager.play('vo_jupiter_bonus_chuckle2');
                                        });
                                        this._soundManager.play('vo_jupiter_bonus_chuckle');
                                    });
                                } else {
                                    this._soundManager.play('vo_jupiter_bonus_laugh');
                                }
                            }

                            if (response.feature.type === 'payout') {
                                // Player has won a credits prize

                                this._soundManager.play('free_spin_summary');
                                const textObj = this._componentManager.get('BonusWheelCreditsWinText');

                                let formattedText = this._translationsManager.get('framework.youwon').replace('{0}',
                                    this._currencyFormatter.format(response.feature.win));

                                textObj.setText(formattedText);
                                textObj.show();

                                let totalWin = response.feature.win;

                                // add on any previous wins in base game from promo spins
                                if (this._freeSpinsPromoModel.isInProgress) {
                                    totalWin += (response.stats.freespins.win - response.win);
                                }

                                this._componentManager.get('WinMeter').setValue(this._currencyFormatter.format(totalWin));
                                this._freeGameModel.isReturningFrom = true;
                            } else {
                                // Player has won free spins
                                this._soundManager.play('freespin_congratulation');
                                const textObj = this._componentManager.get('FreeGameIntroLabel');

                                let formattedText = this._translationsManager.get('framework.youwonspins').replace('{0}',
                                    response.feature.value);

                                textObj.setText(formattedText);
                                textObj.show();
                            }

                            TweenMax.delayedCall(closeDelay, () => {
                                this._componentManager.get('FreeGamePopup').hide();
                                this._componentManager.get('BonusWheelCreditsWinText').hide();
                                this._componentManager.get('FreeGameIntroLabel').hide();
                            });
                        });
                    });
                });

                TweenMax.delayedCall(delayUntilCompleteEventFired, () => {
                    // Remove the mask on the reels that were applied in ShowSpinnerCmd
                    for (const reel of this._componentManager.get('Reels').reels) {
                        reel.mask = null;
                    }

                    this._layerManager.setVisibility('Modals', false);
                    this._layerManager.setVisibility('Spinner', false);
                    this._componentManager.get(`SpinnerOuterValueLightning${iconIndex + 1}`).stop();
                    this._componentManager.get(`SpinnerOuterValue${iconIndex + 1}`).skipToFrame(0);
                    this._soundManager.stop('wheel_electricity');
                    this._componentManager.get('LightningSeparator').stop();


                    //we need to re-set the base game music.
                    if (response.feature.type === 'payout' && !this._bigWinModel.check(response.win, this._betModel.getCurrentBet())) {
                        //but not if we have a big win, please
                        this._audioModel.setBaseGameMusicToWinning();
                    }

                    this._componentManager.get('JupiterBaseGame').changeAnimation('idle', false, true);
                    this._eventManager.publish('onSpinnersComplete');

                    if (response.feature.type === 'payout'){
                        for (const key of Object.keys(creditMultiplierAngles)) {
                            this._componentManager.get(`SpinnerInnerValue${key}X`).hide();
                            this._componentManager.get(`SpinnerInnerValueHighlight${key}X`).hide();
                        }
                    }else{
                        for (const key of Object.keys(fsMultiplierAngles)) {
                            this._componentManager.get(`SpinnerInnerValue${key}X`).hide();
                            this._componentManager.get(`SpinnerInnerValueHighlight${key}X`).hide();
                        }
                    }
                });
            });
        }
    }
}